import { Divider, Box, Button, Card, CardActions, CardContent, Grid, Pagination, Typography } from "@mui/material";
import { useAdvisorContext } from "../hooks/useAdvisorContext";
import { useState } from "react";
import { IReviewerView } from "../types/interfaces/IReviewerView";
import { IAdvisorPlanListProps } from "../types/interfaces/IAdvisorPlanListProps";
import useGetPlan from "../hooks/useGetPlan";

//This component is responsible for displaying a list of the learning plans to the advisor.
const AdvisorPlanList: React.FC<IAdvisorPlanListProps> = ({ onSelect }) => {

    const { reviewerViewArray, setIndividualLearningPlan } = useAdvisorContext();
    const reviewerViews: IReviewerView | any = reviewerViewArray?.flatMap(view => view);
    const [page, setPage] = useState(1);
    const plansPerPage = 3;
    const count = Math.ceil(reviewerViews?.length / plansPerPage);

    const [getPlanFetch, loading] = useGetPlan();

    //Function to handle the page change.
    const pageChange = (event: React.ChangeEvent<unknown>, value: number) => {
        setPage(value);
    };

    //Function to handle a button click.
    const handleClick = async (ilpKey: string) => {
        if (!ilpKey) return
            const fetchedPlan = await getPlanFetch(ilpKey); 
            if (fetchedPlan) {
                setIndividualLearningPlan(fetchedPlan);
                onSelect(fetchedPlan);
            }
    };
    
    return (
        <>
            <Typography variant="h6" color="black" component="div">
                <Box sx={{ fontWeight: 'bold' }}>Learning Plans</Box>
            </Typography>
            <Grid container spacing={1} sx={{mt:1}}>
                {reviewerViews?.slice((page - 1) * plansPerPage, page * plansPerPage).map((view: IReviewerView[] | any ) => (
                    <Grid item xs={12} sm={6} md={4} key={view.IlpKey} style={{ display: 'flex', flexDirection: 'column' }}>
                        <Card sx={{ border: 1, borderColor: 'divider' }}>
                            <CardContent sx={{ paddingBottom: 0 }}>
                                <Box display="flex" alignItems="center">
                                    <Typography variant="body2" fontWeight="bold" color="black" mr={1}>Learner Name:</Typography>
                                    <Typography variant="body2" component="div" sx={{ wordBreak: 'break-word' }}>{view.LearnerFirstName} {view.LearnerLastName}</Typography>
                                </Box>
                                <Box display="flex" alignItems="center">
                                    <Typography variant="body2" fontWeight="bold" color="black" mr={1}>ILP Name:</Typography>
                                    <Typography variant="body2" component="div" sx={{wordBreak: 'break-word'}}>{view.PlanName}</Typography>
                                </Box>
                            </CardContent>
                            <CardActions>
                                {(view.PlanStatus === 'Approved' || view.PlanStatus === "Submitted") && (
                                    <Button variant="contained" color="primary" onClick={() => handleClick(view.IlpKey)} sx={{ml:1, maxWidth: 100, fontSize:18}}>View</Button>
                                )}
                            </CardActions>
                        </Card>
                    </Grid>
                ))}
            </Grid>
            <Pagination count={count} page={page} onChange={pageChange} variant="outlined" shape="rounded" showFirstButton showLastButton sx={{mt:1, mb:5}} />
            <Divider sx={{mt:1, mb:5}}></Divider>
        </>
    );
}

export default AdvisorPlanList;